import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './RoundTicker.css';

//  ---------------------------------
class RoundTicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ticks: 0
    };
    this.interval = null;
  }

  //  ---------------------------------
  setTicker() {
    if (this.props.rounds > 1) {
      this.interval = setInterval(() => {
        this.setState({ ticks: this.state.ticks + 1 });
      }, this.props.step);
    } else {
      clearInterval(this.interval);
    }
  }

  componentDidMount() {
    // console.log('RoundTicker.componentDidMount', this.props);
    this.setTicker();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.step !== prevProps.step ||
      this.props.rounds !== prevProps.rounds
    ) {
      // console.log('RoundTicker.componentDidUpdate', this.props);
      this.setTicker();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  //  ---------------------------------
  //  render

  render() {
    const { rounds, children, step, className, ...otherProps } = this.props;
    const stage = rounds > 1 ? this.state.ticks % rounds : 0;
    return (
      <div className={`round-ticker-${stage} ${className}`} {...otherProps}>
        {children}
      </div>
    );
  }
}

RoundTicker.propTypes = {
  rounds: PropTypes.number,
  step: PropTypes.number
  // onSomething: PropTypes.func
};

RoundTicker.defaultProps = {
  rounds: 3,
  className: '',
  step: 1000 /*ms*/
};

//  ---------------------------------
export default RoundTicker;
